import { mapEnumToOptions } from '@abp/ng.core';

export enum SortEnumCreatorSearch {
  MostFollowers = 1,
  MostRegisteredItems = 2,
  NewestAccountRegistration = 3,
}

export const sortEnumCreatorSearchOptions = mapEnumToOptions(SortEnumCreatorSearch);
